import React from 'react';
import { ContentfulImage } from '../Contentful';
import { ImageAspectBox1x1 } from './ImageAspectBox/ImageAspectBox';
import { VideoCarousel } from './VideoCarousel';
import { VideoCarouselProvider } from './VideoCarousel/Providers/VideoCarouselProvider';
import { VideoPlayer } from './VideoPlayer';
const MediaSwitch = ({ media, className, }) => {
    if (media.contentType === 'compactCarousel') {
        return (React.createElement(VideoCarouselProvider, null,
            React.createElement(VideoCarousel, { className: className, videos: media.videos, compact: true, contentType: "compactCarousel" })));
    }
    else if (media.contentType === 'squareVideo') {
        return (React.createElement(VideoPlayer, { className: className, ...media }));
    }
    else if (media.contentType === 'wideVideo') {
        return React.createElement(VideoPlayer, { className: className, ...media });
    }
    else if (media.contentType === 'fluidImage') {
        return (React.createElement("div", { className: className },
            React.createElement("img", { src: media.asset.file.url, alt: media.asset.description })));
    }
    else if (media.contentType === 'image') {
        return (React.createElement(ImageAspectBox1x1, { className: className },
            React.createElement(ContentfulImage, { asset: media.asset })));
    }
    return null;
};
export const Media = ({ media, image, className, }) => {
    if (!image && !media) {
        return null;
    }
    return (media === null || media === void 0 ? void 0 : media.contentType) ? (React.createElement(MediaSwitch, { media: media, className: className })) : (React.createElement(React.Fragment, null, image && (React.createElement(ImageAspectBox1x1, null,
        React.createElement(ContentfulImage, { asset: image })))));
};
